<div class="atlas-table">
  <div class="header-bar mb-21 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center">
    <div>
      <span>
        {{ 'committees.edit.committee-members.there-are' | translate | ucfirst }}
        <strong>{{ selectedCount }} {{ 'committees.edit.committee-members.group-add-dialog.tagged-profiles' | translate }}</strong>
        {{ 'committees.edit.committee-members.to-take-action-on' | translate }}
      </span>
    </div>
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-10">
      <span *ngIf="!searchResult?.TotalCount; else resultsReturned" class="no-results">
        {{ 'committees.edit.committee-members.group-add-dialog.no-results' | translate | ucfirst }}
      </span>
      <ng-template #resultsReturned>
        <span>
          {{ 'committees.edit.committee-members.group-add-dialog.the-search-returned' | translate | ucfirst }}
          <strong>{{ searchResult.TotalCount }} {{ 'committees.edit.committee-members.group-add-dialog.profiles' | translate }}</strong>
        </span>
      </ng-template>
      <button
        type="button"
        class="atlas-btn atlas-btn-secondary mct-flex mct-row mct-justify-center mct-items-center"
        (click)="clearSearch()"
      >
        <i class="pi pi-times"></i>
        <span>{{ 'common.clear-search' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [lazy]="true"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [loading]="loading"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="t-ac" [style]="{ width: '40px' }">
          <p-checkbox binary="true" [(ngModel)]="selectAll" (onChange)="onSelectAllChange()"></p-checkbox>
        </th>
        <th pSortableColumn="ProfileId" [style]="{ width: '110px' }">
          {{ 'committees.edit.committee-members.group-add-dialog.profile-id' | translate | titlecase }}
          <p-sortIcon field="ProfileId"></p-sortIcon>
        </th>
        <th pSortableColumn="ReportName">
          {{ 'committees.edit.committee-members.group-add-dialog.report-name' | translate | titlecase }}
          <p-sortIcon field="ReportName"></p-sortIcon>
        </th>
        <th pSortableColumn="Email">
          {{ 'committees.edit.committee-members.group-add-dialog.email' | translate | titlecase }}
          <p-sortIcon field="Email"></p-sortIcon>
        </th>
        <th>{{ 'committees.edit.committee-members.group-add-dialog.type' | translate | titlecase }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-profile>
      <tr>
        <td class="t-ac">
          <p-checkbox binary="true" [ngModel]="itemIsSelected(profile)" (ngModelChange)="onRowSelectionChange(profile)"></p-checkbox>
        </td>
        <td>
          {{ profile.ProfileId }}
        </td>
        <td>
          <div class="mct-flex mct-row mct-gap-10">
            <wl-profile-type-icon
              [memberTypeIconColor]="profile.MemberTypeIconColor"
              [isMember]="profile.Member"
              [isOrg]="profile.OrgInd"
            ></wl-profile-type-icon>
            <span>{{ profile.ReportName }}</span>
          </div>
        </td>
        <td>
          {{ profile.Email }}
        </td>
        <td>
          {{ profile.EmailType }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
